import apiClient from "../api/apiClient";
import { endPoints } from "../config/endpoints";

export const providerService = {
  async getAllAsync(params) {
    const response = await apiClient.get(endPoints.provider.getAll, {
      params: params,
    });

    return response.data;
  },
  async getAllSearchAsync(params, signal) {
    const response = await apiClient.get(endPoints.provider.getAllSearch, {
      params: params,
      signal: signal,
    });

    return response.data;
  },

  async create(data) {
      const response = await apiClient.post(endPoints.provider.create, data);
      return response.data;
  },
   async update(id,data) {
      const response = await apiClient.post(`${endPoints.provider.update}/${id}`, data);
      return response.data;
  },
  async toggleActivate(id) {
      const response = await apiClient.patch(`${endPoints.provider.toggleActivate}/${id}`);
      return response.data;
  },
  async toggleProviderDashboard(id) {
      const response = await apiClient.patch(`${endPoints.provider.toggleProviderDashboard}/${id}`);
      return response.data;
  },
  async edit(id) {
      const response = await apiClient.get(`${endPoints.provider.edit}/${id}`);
      return response.data;
  },
  
  async getDetail(id) {
      const response = await apiClient.get(`${endPoints.provider.getDetail}/${id}`);
      return response.data;
  },
  async deleteImageAsync(id) {
      const response = await apiClient.delete(`${endPoints.provider.deleteImage}/${id}`);
      return response.data;
  }
  
};
